import { useState } from "react";
import TextEffect from "../../components/CustomTexts/TextEffect";
import CallToActionSection from "../../components/Others/CallToActionSection";
import heroImage from "../../assets/trainee.png";
import bgIMG from "../../assets/tan_bkgrd.jpg";
import TextFade from "../../components/CustomTexts/TextFade";
import img1 from "../../assets/Shabu-Training-2021/work.jpg";
import img2 from "../../assets/chysonbig.png";
import img3 from "../../assets/Farm/WhatsApp Image 2025-03-31 at 23.28.26_70062493.jpg";
import img4 from "../../assets/Farm/gallery.jpg";
import img5 from "../../assets/Farm/omo.jpg";
import img6 from "../../assets/grass.jpg";
import img7 from "../../assets/Shabu-Training-2021/simmer.jpg";
import img8 from "../../assets/Ohaji-Farm/3.jpg";
import img9 from "../../assets/Shabu-Training-2021/9.jpg";
import img10 from "../../assets/Soil-Sampling/Soil Sampling - 13.jpg";
import img11 from "../../assets/Shabu-Training-2021/big.jpg";
import img12 from "../../assets/Shabu-Training-2021/traininh.jpg";

import img13 from "../../assets/Shabu-Training-2021/5.jpg";
import img14 from "../../assets/Ohaji-Farm/2.jpg";
import img15 from "../../assets/Irrigation-System/Irrigation System - 3.jpg";


import img16 from "../../assets/Vine-Cutting- Planting/Vine Cutting and Planting - 6.jpg";
import img17 from "../../assets/Ohaji-Farm/1.jpg";
import img18 from "../../assets/Soil-Sampling/Soil Sampling - 17.jpg";


import img19 from "../../assets/Irrigation-System/Learning about Drip Irrigation - 2.jpg";
import img20 from "../../assets/Irrigation-System/Irrigation System - 7.jpg";
import img21 from "../../assets/Irrigation-System/Learning about Drip Irrigation - 1.jpg";

import img22 from "../../assets/Farm/WhatsApp Image 2025-03-31 at 23.28.25_958c8aca.jpg";
import img23 from "../../assets/Farm/WhatsApp Image 2025-03-31 at 23.33.39_f3ffe9a4.jpg";
import img24 from "../../assets/Farm/FB_IMG_1741643935624.jpg";

import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

import vineCutting4 from "../../assets/Vine-Cutting- Planting/Learning about Drip Irrigation - 10.mp4";
import IrrigationVid from "../../assets/Irrigation-System/Irrigation System - 4.mp4";
import vineCutting3 from "../../assets/Vine-Cutting- Planting/Vine Cutting and Planting - 3.mp4";
import soilSample1 from "../../assets/Soil-Sampling/Soil Sampling - 11.mp4";
import IrrigationVid2 from "../../assets/Irrigation-System/Irrigation System - 5.mp4";
import vineCutting7 from "../../assets/Vine-Cutting- Planting/Learning about Drip Irrigation - 11.mp4";
import soilSample from "../../assets/Soil-Sampling/Soil Sampling - 1.mp4";
import vineCutting1 from "../../assets/Vine-Cutting- Planting/Vine Cutting and Planting - 5.mp4";
import soilSample2 from "../../assets/Soil-Sampling/Soil Sampling - 12.mp4";
import vineCutting from "../../assets/Vine-Cutting- Planting/Vine Cutting and Planting - 14.mp4";
import vineCutting2 from "../../assets/Vine-Cutting- Planting/Vine Cutting and Planting - 10.mp4";
import vineCutting5 from "../../assets/Vine-Cutting- Planting/Vine Cutting and Planting - 2.mp4";
import vineCutting6 from "../../assets/Vine-Cutting- Planting/Vine Cutting and Planting - 1.mp4";
import Book1 from "../../assets/Simdozi-BookArtboard-1.png";
import Book2 from "../../assets/Simdozi-BookArtboard-2.png";
import { Link } from "react-router-dom";


const ImageModal = ({
  image,
  caption,
  isVideo = false,
  onClose
}: {
  image: string;
  caption: string;
  isVideo?: boolean;
  onClose: () => void;
}) => (
  <div className="fixed inset-0 bg-black bg-opacity-80 z-50 flex items-center justify-center p-4">
    <div className="bg-white rounded-lg shadow-lg max-w-3xl w-full overflow-hidden relative">
      {isVideo ? (
        <video
          src={image}
          controls
          autoPlay
          loop
          className="w-full max-h-[80vh] object-contain"
        />
      ) : (
        <img
          src={image}
          alt={caption}
          className="w-full max-h-[80vh] object-contain"
        />
      )}
      <p className="text-center text-lg font-semibold text-dark py-4">{caption}</p>
      <button
        onClick={onClose}
        className="absolute top-2 right-2 text-white bg-black rounded-full p-2 hover:bg-gray-700"
      >
        ✕
      </button>
    </div>
  </div>
);

const GalleryPage = () => {
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const [modal, setModal] = useState<{ img: string; caption: string; isVideo?: boolean } | null>(null);

  const galleryImages = [
    img1, img2, img3, img4, img5, img6,
    img7, img8, img9, img10, img11, img12,
    img13, img14, img15, img16, img17, img18,
    img19, img20, img21, img22, img23, img24,
  ];

  const trainingGallery = [
    { img: vineCutting3, caption: "Field Experience", isVideo: true },
    { img: IrrigationVid, caption: "Irrigation System Process", isVideo: true },
    { img: vineCutting1, caption: "Field Experience", isVideo: true },
    { img: soilSample1, caption: "Soil sampling techniques", isVideo: true },
    { img: vineCutting4, caption: "Field Experience", isVideo: true },
    { img: IrrigationVid2, caption: "Irrigation through vine cutting", isVideo: true },
    { img: vineCutting5, caption: "Field Experience", isVideo: true },
    { img: soilSample, caption: "Soil sampling techniques", isVideo: true },
    { img: vineCutting6, caption: "Field Experience", isVideo: true },
    { img: soilSample2, caption: "Soil sampling techniques", isVideo: true },
    { img: vineCutting, caption: "Field Experience", isVideo: true },
    { img: vineCutting2, caption: "Field Experience", isVideo: true },
    { img: vineCutting7, caption: "Field Experience", isVideo: true },
  ];

  const captions = [
    "Empowering Youth Through Training",
    "Our Special Chyson Fries",
    "Freshly Cut Produce",
    "Pink Root Vegetable Harvest",
    "Field Production in Progress",
    "Growing Organic Greens",
    "Training Material Setup",
    "Documentation at Work",
    "Our Trainee Sessions",
    "Crop Assessment",
    "Our Team's Legacy",
    "New Initiative Launch",
    "Training in Action",
    "Crop Assessment",
    "Our Team's Legacy",
    "New Initiative Launch",
    "Training in Action",
    "Crop Assessment",
    "Our Team's Legacy",
    "New Initiative Launch",
    "Training in Action",
    "Crop Assessment",
    "Our Team's Legacy",
    "New Initiative Launch",
  ];

  return (
    <div className="about-container">
      {/* Hero */}
      <div
        className="relative h-[60vh] flex items-center justify-center text-white bg-cover bg-center z-0"
        style={{ backgroundImage: `url(${heroImage})` }}
      >
        <div className="absolute inset-0 bg-black opacity-50 z-0"></div>
        <div className="z-10">
          <TextEffect text="Gallery" className="hero-title" />
        </div>
      </div>
{/* Dual Book Display - Power of Nutrition & The Power of Seeds */}
<div className="flex px-4 sm:px-[5%] md:flex-row flex-col justify-between items-center mt-20 md:gap-20 gap-10">

  {/* Left Book */}
  <div className="md:w-[50%] w-full flex flex-col items-start">
    <TextFade animation="fade-down">
      <h1 className="md:text-[60px] text-[28px] font-bold text-dark mb-6">
        <TextEffect text3="Commercial Orange Fleshed" />
      </h1>
    </TextFade>
    <p className="text-dark md:text-[20px] text-[15px] italic font-serif tracking-wide leading-loose mb-6">
      Published in 2020, the orange-fleshed sweet potato is the new breed that is bio-fortified and contains high amount of beta-carotene. 
      Experts have the opinion that the crop has become very essential in Nigeria because, according to studies, over 30 per cent of pre-school aged children are deficient in vitamin A, while 36 per cent of children under five years are stunted due to lacks of the vitamin.
    </p>
    <div className="flex gap-4 mb-6">
      <Link to="/contact">
        <button className="border border-green-700 text-green-700 px-4 py-2 rounded-md hover:bg-green-100 transition">
          Book a Copy
        </button>
      </Link>
      <a
        href="https://www.premiumtimesng.com/agriculture/agric-interviews/697390-the-farmer-lamented-that-the-potato-value-chain-in-nigeria-has-been-neglected-and-is-not-given-the-necessary-support-by-the-government.html"
        target="_blank"
        rel="noopener noreferrer"
        className="border border-green-700 text-green-700 px-4 py-2 rounded-md hover:bg-green-100 transition text-center"
      >
        View Publication
      </a>
    </div>
    <div className="flex justify-center w-full">
      <img
        src={Book1}
        alt="Power of Nutrition"
        className="w-[90%] sm:w-full max-w-[450px] md:max-w-[500px] rounded-lg shadow-md transition-transform duration-300 hover:scale-105"
      />
    </div>
  </div>

  {/* Right Book */}
  <div className="md:w-[50%] w-full flex flex-col items-start">
    <TextFade animation="fade-down">
      <h1 className="md:text-[60px] text-[28px] font-bold text-dark mb-6">
        <TextEffect text3="Training Manual On Production & Utilization" />
      </h1>
    </TextFade>
    <p className="text-dark md:text-[20px] text-[15px] italic font-serif tracking-wide leading-loose mb-6">
      Training Manual on Production & Utilization of OFSP is your essential guide to thriving in the modern agro-economy. Published in 2021, it covers best practices in OFSP cultivation, value addition, processing, and diverse applications—from nutrition to agribusiness.
    </p>
    <div className="flex gap-4 mb-6">
      <Link to="/contact">
        <button className="border border-green-700 text-green-700 px-4 py-2 rounded-md hover:bg-green-100 transition">
          Book a Copy
        </button>
      </Link>
      <a
        href="https://www.researchgate.net/publication/361944646_Anti-Bacterial_Phytochemical_Analysis_and_Blood_Pressure_Lowering_Effects_of_Orange_Flesh_Sweet_Potatoes_Ipomoea_Batatas_L?_tp=eyJjb250ZXh0Ijp7ImZpcnN0UGFnZSI6Il9kaXJlY3QiLCJwYWdlIjoicHJvZmlsZSIsInByZXZpb3VzUGFnZSI6Il9kaXJlY3QifX0"
        target="_blank"
        rel="noopener noreferrer"
        className="border border-green-700 text-green-700 px-4 py-2 rounded-md hover:bg-green-100 transition text-center"
      >
        View Publication
      </a>
    </div>
    <div className="flex justify-center w-full">
      <img
        src={Book2}
        alt="Power of Seeds"
        className="w-[90%] sm:w-full max-w-[450px] md:max-w-[500px] rounded-lg shadow-md transition-transform duration-300 hover:scale-105"
      />
    </div>
  </div>


</div>

      {/* Image Gallery */}
      <div
        className="relative py-20 mt-24 px-4 sm:px-[5%] bg-cover bg-center"
        style={{ backgroundImage: `url(${bgIMG})` }}
      >
        <div className="absolute inset-0 bg-green-550 bg-opacity-60 z-0"></div>
        <div className="relative z-0">
          <h2 className="text-center text-white text-[24px] sm:text-[32px] md:text-[40px] font-bold mb-10">
            <TextEffect text1="See Us In Action" />
          </h2>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
            {galleryImages.map((img, index) => (
              <div
                key={index}
                className="relative overflow-hidden rounded-lg cursor-pointer group"
                onClick={() => setSelectedImage(img)}
              >
                <img
                  src={img}
                  alt={`Gallery ${index + 1}`}
                  className="w-full h-[200px] sm:h-[220px] object-cover transform group-hover:scale-110 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-black opacity-0 group-hover:opacity-40 transition-opacity duration-300" />
                <p className="text-white text-center text-sm mt-2">{captions[index]}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Full Image Modal */}
      {selectedImage && (
        <div
          className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center transition-opacity duration-500 opacity-100"
          onClick={() => setSelectedImage(null)}
        >
          <img
            src={selectedImage}
            alt="Full View"
            className="max-w-[95%] max-h-[90%] object-contain rounded-lg shadow-2xl transition-transform duration-500 scale-100"
          />
          <button
            onClick={() => setSelectedImage(null)}
            className="absolute top-5 right-5 text-white text-3xl font-bold"
          >
            ×
          </button>
        </div>
      )}

      {/* Video/Image Carousel */}
      <div className="px-4 sm:px-[5%] mt-24 mb-20">
        <TextFade animation="fade-up">
          <h1 className="text-center text-[24px] md:text-[36px] font-bold text-dark mb-8">
            <TextEffect part3="Our Videos" />
          </h1>
        </TextFade>

        <Swiper
          spaceBetween={20}
          slidesPerView={1}
          breakpoints={{
            640: { slidesPerView: 1.5 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
          navigation
          autoplay={{ delay: 3000 }}
          loop
          modules={[Navigation, Autoplay]}
        >
          {trainingGallery.map(({ img, caption, isVideo }, index) => (
            <SwiperSlide key={index}>
              <div
                className="relative w-full h-[260px] sm:h-[300px] rounded-xl overflow-hidden group"
                onClick={() => setModal({ img, caption, isVideo })}
              >
                {isVideo ? (
                  <video
                    src={img}
                    autoPlay
                    loop
                    muted
                    playsInline
                    className="w-full h-full object-cover"
                  />
                ) : (
                  <img
                    src={img}
                    alt={`Training ${index + 1}`}
                    className="w-full h-full object-cover group-hover:scale-105 transition-all duration-300"
                  />
                )}
                <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center text-white text-lg font-semibold text-center p-4">
                  {caption}
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      {modal && (
        <ImageModal
          image={modal.img}
          caption={modal.caption}
          isVideo={modal.isVideo}
          onClose={() => setModal(null)}
        />
      )}

      <CallToActionSection />
    </div>
  );
};

export default GalleryPage;
